<app-card surface="white" styleClass="px-sm py-xs !rounded-md">
  @if (items().length === 0) {
    <p class="text-xs text-gray-text">{{ 'noData' | translate }}</p>
  } @else {
    <nav class="flex items-center gap-sm text-xs" aria-label="breadcrumbs">
      @for (item of items(); track item.id; let index = $index; let first = $first; let last = $last) {
        @if (!first) {
          <span class="text-light-text" aria-hidden="true">›</span>
        }
        <button
          #crumb
          type="button"
          class="cursor-pointer whitespace-nowrap rounded-md px-xs py-xs outline-none transition-colors hover:text-secondary"
          [class.flex]="first"
          [class.items-center]="first"
          [class.bg-bg-soft]="activeIndex() === index"
          [class.text-dark-text]="activeIndex() === index || last"
          [class.font-semibold]="activeIndex() === index || last"
          [class.text-gray-text]="activeIndex() !== index && !last"
          [attr.tabindex]="activeIndex() === index ? 0 : -1"
          [attr.aria-current]="last ? 'page' : null"
          (mousedown)="$event.preventDefault()"
          (click)="openItem(item)"
        >
          @if (first) {
            <ic-home
              startColor="var(--color-primary-start-color)"
              endColor="var(--color-primary-end-color)"
            ></ic-home>
          } @else if (item.isDynamic) {
            {{ item.itemName || '-' }}
          } @else {
            {{ item.itemName | translate }}
          }
        </button>
      }
    </nav>
  }
</app-card>
